import { FC } from 'react';
import Drawer from '..';
import DrawerHeader from '../header';
import DrawerContent from '../content';
import { useQuery } from 'react-query';
import { Box, Stack, Theme } from '@mui/material';
import { createUseStyles } from 'react-jss';
import { QueryKey } from '@/lib/query-client';
import { getMcpServerById } from '@/lib/services/mcp.service';
import { McpServerModel } from '@/lib/models/mcp-server.model';
import RouterTabs from '@/components/router-tabs';
import Details from './details';
import Tools from './tools';
import InlineToast from '@/components/toasts/inline';
import { DrawerProps } from '../helpers';

interface Props extends DrawerProps {
  id: string;
  defaultToolId?: string;
}

const useStyles = createUseStyles((theme: Theme) => ({
  icon: {
    width: 32,
    height: 32,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
}));

export const McpServerDrawer: FC<Props> = ({
  id,
  defaultToolId,
  open,
  onClose,
  className,
  isTopDrawer,
}) => {
  const styles = useStyles();

  const query = useQuery([QueryKey.McpServerView, id], async () => getMcpServerById(id));
  const { data = new McpServerModel() } = query;

  const { title, icon } = data!;
  const hasIcon = !!icon;

  const NameEl = (
    <Stack direction="row" gap={2} width="100%">
      {hasIcon && <img src={icon} className={styles.icon} />}
      <Box>{title}</Box>
    </Stack>
  );

  return (
    <Drawer open={open} onClose={onClose} className={className} query={query}>
      <DrawerHeader onClose={onClose} isTopDrawer={isTopDrawer}>
        {NameEl}
      </DrawerHeader>
      <DrawerContent>
        {data ? (
          <RouterTabs
            variant="drawer"
            panels={[
              {
                label: 'Server Details',
                icon: 'info-circle',
                path: 'profile',
                component: <Details data={data} />,
              },
              {
                label: 'Tools',
                icon: 'mcp-server',
                path: 'tools',
                component: <Tools id={id} defaultToolId={defaultToolId} />,
              },
            ]}
          />
        ) : (
          <InlineToast
            message="MCP server not found. Please try again. If the problem persists, please contact support."
            level="error"
          />
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default McpServerDrawer;
